import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import axios from 'helpers/api';
import { createIframeReportBlobUrl } from 'helpers/iframeReportPreview';
import Spinner from 'react-bootstrap/Spinner';
import { toast } from 'react-toastify';


const PatientDrugInfoReport = () => {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [iframeSrc, setIframeSrc] = useState(null);

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        let tokenStr = localStorage.getItem("accessToken");
        let patientId = localStorage.getItem("patientId");
        let patientDrugInfoUrl = `${process.env.REACT_APP_SERVER_URL}` + "/drugs/patient-drug-info/" + patientId;

        try {
            const response = await axios.get(patientDrugInfoUrl, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            if (response.data && response.data.status === false) {
                 toast.error(response.data.message || "Failed to print content.");
                return;
            }
            const { blobUrl } = await createIframeReportBlobUrl(response.data);
            setIframeSrc(blobUrl);
        } catch (err) {
            const apiMessage = err?.response?.data?.message || err?.response?.data?.error;
            toast.error(apiMessage || "Failed to print content.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div style={{
                height: 0,
                overflow: 'hidden',
                // width: 0
            }}>
                {iframeSrc && (
                    <iframe
                        src={iframeSrc}
                        style={{ width: "100%", height: "500px", border: "none" }}
                        title="Preview Content"
                    />
                )}
            </div>
            <Form>
                {error && <div className="text-danger text-start">{error}</div>}
                <div className="text-end px-3 mt-3">
                    {!loading ? <Button className="btn btn-primary" onClick={handleSubmit}>
                        Generate
                    </Button> : <Spinner animation="border" role="status" size="sm"></Spinner>}
                </div>
            </Form>
        </>
    );
};

PatientDrugInfoReport.propTypes = {
    layout: PropTypes.string,
    hasLabel: PropTypes.bool
};

PatientDrugInfoReport.defaultProps = {
    layout: 'simple',
    hasLabel: false
};

export default PatientDrugInfoReport;
